var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{staticClass:"uim-tooltip"},[_c('div',{staticClass:"tooltip-inner"},[_vm._t("tooltip-inner")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }